import React from "react"
import CountUp from "react-countup"
import { useInView } from "react-intersection-observer"

interface CounterProps {
  className: string
  end: number
  toggleOneDecimalPlace: boolean
}

const Counter = ({ className, end, toggleOneDecimalPlace }: CounterProps) => {
  const { ref: inViewRef, inView } = useInView({
    triggerOnce: true,
    delay: 300,
  })

  const formatNumber = (value: number) => {
    if (value === 0) {
      return "0"
    }
    if (toggleOneDecimalPlace) {
      return value.toFixed(1)
    }
    return value.toFixed(value % 1 === 0 ? 0 : 1)
  }

  return (
    <div ref={inViewRef}>
      <CountUp
        start={inView ? 0 : null}
        end={end}
        duration={1.5}
        formattingFn={formatNumber}
      >
        {({ countUpRef }) => <h3 className={className} ref={countUpRef} />}
      </CountUp>
    </div>
  )
}

export default Counter
